import { Link, router } from '@inertiajs/react'
import { AdminShell } from '@/components/layout/AdminShell'
import { PageHeader } from '@/components/landing/PageHeader'
import { Badge } from '@/components/ui/badge'
import { Button } from '@/components/ui/button'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table'

interface AdminUser {
  id: string
  email: string
  role: string
  suspended: boolean
  suspended_at: string | null
  created_at: string
  org_name: string | null
}

interface Props {
  admin: { email: string }
  users: AdminUser[]
}

export default function Index({ admin, users }: Props) {
  function impersonate(userId: string) {
    router.post('/admin/impersonations', { user_id: userId })
  }

  return (
    <AdminShell admin={admin}>
      <div className="space-y-8">
        <PageHeader
          eyebrow="Admin"
          title="Users"
          description={`${users.length} user${users.length !== 1 ? 's' : ''} total.`}
        />

        <div className="surface-card overflow-hidden">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Email</TableHead>
                <TableHead>Role</TableHead>
                <TableHead>Organization</TableHead>
                <TableHead>Status</TableHead>
                <TableHead>Joined</TableHead>
                <TableHead />
              </TableRow>
            </TableHeader>
            <TableBody>
              {users.map((user) => (
                <TableRow key={user.id}>
                  <TableCell className="font-medium">{user.email}</TableCell>
                  <TableCell>
                    <Badge variant={user.role === 'super_admin' ? 'destructive' : 'secondary'}>
                      {user.role}
                    </Badge>
                  </TableCell>
                  <TableCell className="text-muted-foreground">
                    {user.org_name ?? '—'}
                  </TableCell>
                  <TableCell>
                    <Badge variant={user.suspended ? 'destructive' : 'default'}>
                      {user.suspended ? 'suspended' : 'active'}
                    </Badge>
                  </TableCell>
                  <TableCell className="text-muted-foreground text-sm">
                    {new Date(user.created_at).toLocaleDateString()}
                  </TableCell>
                  <TableCell>
                    <div className="flex items-center gap-2 justify-end">
                      {user.role !== 'super_admin' && (
                        <Button size="sm" variant="outline" onClick={() => impersonate(user.id)}>
                          Impersonate
                        </Button>
                      )}
                      <Button size="sm" variant="ghost" asChild>
                        <Link href={`/admin/users/${user.id}`}>View</Link>
                      </Button>
                    </div>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </div>
    </AdminShell>
  )
}
